import React from 'react';
import styled from 'styled-components';
import { Translation } from '~/components/Translation';
import ResponsiveText from '~/components/ResponsiveText';
import FeatureCard from './components/FeatureCard';

const Container = styled.div`
	display: flex;
	padding: 20px 80px 120px;
	flex-direction: column;
	align-items: center;
	gap: 40px;

	@media (max-width: 1080px) {
		padding: 40px 20px;
	}
`;

const HeaderContainer = styled.div`
	display: flex;
	max-width: 620px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 24px;
`;

const Title = styled(ResponsiveText)`
	text-align: center;
`;

const Subtitle = styled(ResponsiveText)`
	justify-self: center;
	text-align: center;
	margin: 0 50px;
	max-width: 800px;

	@media (max-width: 500px) {
		margin: 0 50px;
	}
`;

const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, 350px);
	justify-content: center;
	gap: 40px;
	width: 100%;
	max-width: 1140px; /* 3 * 350px + 2 * 40px gap */

	@media (max-width: 1200px) {
		grid-template-columns: repeat(auto-fit, 350px);
		max-width: 740px; /* Force 2 columns on medium screens */
		justify-content: center;
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		max-width: 350px; /* Single column on small screens */
		justify-content: center;
	}
`;

export interface Feature {
	iconSrc: string;
	titleKey: string;
	descriptionKey: string;
}

interface FeatureGridProps {
	titleKey: string;
	subtitleKey?: string;
	features: Feature[];
}

const FeatureGrid: React.FC<FeatureGridProps> = ({
	titleKey,
	subtitleKey,
	features,
}) => {
	return (
		<Container>
			<HeaderContainer>
				<Title variant="h2">
					<Translation tid={titleKey} />
				</Title>
				{subtitleKey && (
					<Subtitle variant="body">
						<Translation tid={subtitleKey} />
					</Subtitle>
				)}
			</HeaderContainer>
			<GridContainer>
				{features.map((feature, index) => (
					<FeatureCard
						key={index}
						iconSrc={feature.iconSrc}
						titleKey={feature.titleKey}
						descriptionKey={feature.descriptionKey}
					/>
				))}
			</GridContainer>
		</Container>
	);
};

export default FeatureGrid;
